import TabPanel from '../Reusable/Tab'
import AssignGroup from './AssignGroup'
import ChangePassword from './ChangePassword'
import UpdateUserProfile from './UpdateUserProfile'
import UserLoginInfo from './UserLoginInfo'

const UpdateUser = (props: any) => {
  const { data, roles, profile } = props
  return (
    <>
      <TabPanel
        tabTitle={["Update User", "Profile", "Roles", "Address", "Change Password"]}
        tabPanels={[
          <>
            <UserLoginInfo user={data} profile={profile}/>
          </>
          ,
          <>
            <UpdateUserProfile user={data} />
          </>
          ,
          <><AssignGroup roles={roles} user={data}/></>
          ,
          <><h1>Hello world</h1></>,
          <>
            <div className='max-w-md'>
            <ChangePassword user={data}  email={data?.email}/>
            </div>
          </>
        ]}
      />
    </>
  )
}

export default UpdateUser